import styled from 'styled-components';
import { devices } from '../../Styles';

export const DrawerContainer = styled.div`
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.palette.white};
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 15px;
  border-radius: 8px 8px 0px 0px;
  box-shadow: ${({ theme }) => `0px 0px 9px ${theme.palette.grays20}`};
  animation: scaleUp 0.5s cubic-bezier(0.165, 0.84, 0.44, 1);
  z-index: 1;
  @media ${devices['no-mobile']} {
    justify-content: space-around;
  }

  @keyframes scaleUp {
    0% {
      transform: translateY(1000px);
      opacity: 0;
    }
    100% {
      transform: translateY(0px);
      opacity: 1;
    }
  }
`;
